import { useMemo } from 'react';

import { encodeQrModules, qrModulesToPath, type QrCodeParams } from '../lib/qrCode';

type QrCodeViewProps = QrCodeParams & {
  label?: string;
  className?: string;
};

export function QrCodeView({
  value,
  size = 240,
  margin = 2,
  darkColor = '#111111',
  lightColor = '#FFFFFF',
  label,
  className,
}: QrCodeViewProps) {
  const { n, path } = useMemo(() => {
    const modules = encodeQrModules(value, margin);
    return { n: modules.length, path: qrModulesToPath(modules) };
  }, [margin, value]);

  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${n} ${n}`}
      shapeRendering="crispEdges"
      className={className}
    >
      <rect width={n} height={n} fill={lightColor} />
      <path d={path} fill={darkColor} />
    </svg>
  );
}
